import { useWhitelabel } from '~/composables/useWhitelabel'

export default defineNuxtPlugin(() => {
  const { app } = useWhitelabel()

  // Update meta tags when whitelabel config changes
  watchEffect(() => {
    useHead({
      meta: [
        { property: 'og:site_name', content: app.value.name }
      ]
    })
  })
})
